import React, { useEffect, useState } from "react";
import { Element, Link } from "react-scroll";

import "animate.css";
import { Col, Row } from "antd";
import { getPagePayload } from "years";

import LineAnimation from "components/LineAnimation";
import LoadingSpin from "components/Loading";
import QuestBlog from "components/QuestBlog";
import ScrollUpBtn from "components/ScrollUpBtn";

import { Container, TextHead, TextSection, Title } from "./questions.style";

const Questions = ({ year }) => {
  const [questionData, setQuestionData] = useState({});
  const [titleList, setTitleList] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataQuestion();
  }, [year]);

  const getDataQuestion = () => {
    setIsLoading(false);
    const response = { data: getPagePayload(year, "question") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setQuestionData(data?.section);
      setTitleList(data);
    } else {
      setIsLoading(true);
      setQuestionData({});
    }
  };

  const renderLink = (to, name) => {
    return (
      <Link
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <TextSection>{name}</TextSection>
      </Link>
    );
  };

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <Title className="animate__animated animate__flipInX animate__slow">
              คําถามที่ถามบ่อย
            </Title>
          </Col>
        </Row>
        {isLoading ? (
          <>
            <Row className="row-section" gutter={[24, 24]}>
              {titleList?.section &&
                titleList?.section?.map((item, index) => {
                  return (
                    <Col key={index} span={12}>
                      {renderLink(item?.name, item?.name)}
                    </Col>
                  );
                })}
            </Row>

            <div className="line-style">
              <LineAnimation />
            </div>

            {questionData.length >= 0 &&
              questionData.map((item, index, row) => {
                return (
                  <div key={`title-${index}`}>
                    <Row className="row-top">
                      <Col span={24}>
                        <Element name={item?.name} key={index}>
                          <TextHead>{item?.name}</TextHead>
                        </Element>
                      </Col>
                      <Col span={24}>
                        {item?.question.length >= 0 &&
                          item?.question.map((item, index) => {
                            return (
                              <QuestBlog
                                top="40"
                                key={`quest-${index}`}
                                headText={item?.question}
                                ansTextFirst={
                                  item?.answer_0 ? item?.answer_0 : ""
                                }
                                ansTextSecon={
                                  item?.answer_1 ? item?.answer_1 : ""
                                }
                                ansTextThird={
                                  item?.answer_2 ? item?.answer_2 : ""
                                }
                              />
                            );
                          })}
                      </Col>
                    </Row>
                    {index + 1 !== row.length && (
                      <div className="line-style">
                        <LineAnimation />
                      </div>
                    )}
                  </div>
                );
              })}
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>

      <ScrollUpBtn />
    </>
  );
};

export default Questions;
